import { render, staticRenderFns } from "./PoiView.vue?vue&type=template&id=6e671db3&scoped=true&"
import script from "./PoiView.vue?vue&type=script&lang=js&"
export * from "./PoiView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e671db3",
  null
  
)

export default component.exports